import { EventEmitter, Input, Output } from '@angular/core';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'sabis-ngx-button',
  templateUrl: './sabis-button2.component.html',
  styleUrls: ['./sabis-button2.component.scss'],
  imports: [MatButtonModule]
})
export class SabisButton2Component {
  @Input('disabled') disabled: boolean = false;
  @Input('color') color: string = 'primary';
  @Output('clicl') click = new EventEmitter();

  public onButtonClick(): void {
    this.click.emit();
  }
}
